import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";
import ReactModal from "react-modal";
import { Button } from "@mui/material";

import { setOpenModalFunction } from "./controller";
import { Container } from "./styles";

interface LogoutModalContextProps {
  openModal: () => void;
}

const LogoutModalContext = createContext<LogoutModalContextProps | undefined>(
  undefined
);

interface LogoutModalProviderProps {
  children: ReactNode;
}

export const LogoutModalProvider = ({ children }: LogoutModalProviderProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const openModal = () => {
    setIsModalOpen(true);
    sessionStorage.setItem("logoutModalOpen", "true");
  };

  useEffect(() => {
    setOpenModalFunction(openModal);
    return () => setOpenModalFunction(null);
  }, []);

  const logout = () => {
    sessionStorage.removeItem("@AXS-Energia:token");
    sessionStorage.removeItem("logoutModalOpen");
    setIsModalOpen(false);
    window.location.href = "/arp/login";
  };

  useEffect(() => {
    const modalOpen = sessionStorage.getItem("logoutModalOpen");
    if (modalOpen === "true") {
      logout();
    }
  }, []);

  ReactModal.setAppElement("#root");

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "760px",
      width: "90%",
    },
  };

  return (
    <LogoutModalContext.Provider value={{ openModal }}>
      {children}
      <ReactModal
        isOpen={isModalOpen}
        style={customStyles}
        overlayClassName={{
          base: "overlay-base",
          afterOpen: "overlay-base_after-open",
          beforeClose: "overlay-base_before-close",
        }}
      >
        <Container>
          <h2>Acesso não autorizado</h2>
          <p>Token expirado</p>
          <Button
            className="download-button"
            type="button"
            onClick={() => {
              logout();
            }}
          >
            OK
          </Button>
        </Container>
      </ReactModal>
    </LogoutModalContext.Provider>
  );
};

export const useLogoutModal = () => {
  const context = useContext(LogoutModalContext);
  if (!context) {
    throw new Error(
      "useLogoutModal deve ser usado dentro de um LogoutModalProvider"
    );
  }
  return context;
};
